import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from 'react';

interface SmartInsightsCtx {
  isEnabled: boolean;
  toggle: () => void;
}

const Ctx = createContext<SmartInsightsCtx>({ isEnabled: false, toggle: () => {} });

export const SmartInsightsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isEnabled, setIsEnabled] = useState<boolean>(() => {
    try {
      const saved = localStorage.getItem('jgjb-smart-insights');
      return saved !== null ? saved === 'true' : false;
    } catch {
      return false;
    }
  });

  useEffect(() => {
    localStorage.setItem('jgjb-smart-insights', String(isEnabled));
  }, [isEnabled]);

  const toggle = useCallback(() => setIsEnabled(prev => !prev), []);

  const value = useMemo<SmartInsightsCtx>(
    () => ({ isEnabled, toggle }),
    [isEnabled, toggle]
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useSmartInsights = () => useContext(Ctx);
